import { render, staticRenderFns } from "./formation.vue?vue&type=template&id=30db7ccb&scoped=true&"
import script from "./formation.vue?vue&type=script&lang=js&"
export * from "./formation.vue?vue&type=script&lang=js&"
import style0 from "./formation.vue?vue&type=style&index=0&id=30db7ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db7ccb",
  null
  
)

export default component.exports